import MiscUtils from '../infra/MiscUtils'

class LambdaUtils {
  
  sendTeamInvitation(inviter, invitee, teamInfo) {
    const invite = this.createInviteParam(inviter, invitee, teamInfo)
    const params = { invites: [invite] }
    return MiscUtils.fetchEndPoint('createTeamInvite', params)
  }

  createInviteParam(inviter, invitee, teamInfo) {
    return {
      team: {
        id: teamInfo.id,
        displayName: teamInfo.displayName
      },
      invitee: {
        id: invitee.userId,
        displayName: invitee.displayName,
        fullName: invitee.fullName,
        role: invitee.role,
        email: invitee.email
      },
      invitationOwner: {
        id: inviter.userId,
        role: inviter.role,
        displayName: inviter.displayName
      }
    }
  }
}

export default LambdaUtils


// WEBPACK FOOTER //
// ./src/infra/LambdaUtils.js